import React, { Fragment } from 'react';
import 'animate.css';
import Icon from '../../Components/Icons/Icon';
import { Dialog, Transition } from '@headlessui/react';
import { useMobile, useStatusBarColour } from '../../Components/Mobile';
import { useSession } from '../../Components/Session';
import RedesignNavSections from '../shared/RedesignNavSections';

const Menu = ({ isOpen, setIsOpen, pins }) => {
    const { showDarkMode } = useSession();
    const { safeAreaInsets } = useMobile();
    useStatusBarColour(isOpen ? (showDarkMode ? '#1E293B' : '#F8FAFC') : null);

    const close = () => setIsOpen(false);

    return (
        <Transition.Root show={isOpen} as={Fragment} appear={true}>
            <Dialog
                as="div"
                className="relative z-30"
                onClose={close}
            >
                <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-200"
                    enterFrom="opacity-0"
                    enterTo="opacity-50"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-50"
                    leaveTo="opacity-0"
                >
                    <div className="fixed inset-0 bg-blue-50/10 dark:bg-slate-900/10 backdrop-blur-lg" />
                </Transition.Child>

                <div className="fixed inset-0 z-10 overflow-hidden">
                    <div className="absolute inset-0 overflow-hidden">
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-200"
                            enterFrom="-translate-x-full"
                            enterTo="translate-x-0"
                            leave="ease-in duration-200"
                            leaveFrom="translate-x-0"
                            leaveTo="-translate-x-full"
                        >
                            <Dialog.Panel className="fixed left-0 inset-y-0 w-[90%] bg-slate-50 dark:bg-slate-800 shadow-xl border-r dark:border-none">
                                <div className="relative flex flex-col h-full">
                                    <button
                                        type="button"
                                        className="absolute right-3 top-2 p-2 rounded-full hover:bg-gray-200 dark:hover:bg-gray-700 transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500/50"
                                        onClick={close}
                                        aria-label="Close menu"
                                    >
                                        <Icon {...{ icon: 'XMark', size: '1.5x', className: 'fill-gray-800 dark:fill-gray-200' }} />
                                    </button>
                                    <div
                                        className="flex-1 px-5 pt-4 pb-3 overflow-y-auto no-scrollbar"
                                        style={safeAreaInsets?.bottom ? { paddingBottom: safeAreaInsets.bottom } : undefined}
                                    >
                                        <RedesignNavSections onNavigate={close} mobile pins={pins} />
                                    </div>
                                </div>
                            </Dialog.Panel>
                        </Transition.Child>
                    </div>
                </div>
            </Dialog>
        </Transition.Root>
    );
};

export default Menu;
